import { render, staticRenderFns } from "./QuestionNPS.vue?vue&type=template&id=cb914d86&scoped=true&"
import script from "./QuestionNPS.vue?vue&type=script&lang=js&"
export * from "./QuestionNPS.vue?vue&type=script&lang=js&"
import style0 from "./QuestionNPS.vue?vue&type=style&index=0&id=cb914d86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb914d86",
  null
  
)

export default component.exports